import React, { useContext } from "react";
import styled from "@emotion/styled";
import { Avatar, Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { GlobalContext } from "../../contexts/GlobalContext";
import { useNavigate } from "react-router-dom";

// import { Badge, Typography } from "@mui/material";

// import useAuth from "../../hooks/useAuth";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

// const FooterText = styled(Typography)`
//   color: ${(props) => props.theme.sidebar.footer.color};
// `;

// const FooterSubText = styled(Typography)`
//   color: ${(props) => props.theme.sidebar.footer.color};
//   font-size: 0.7rem;
//   display: block;
//   padding: 1px;
// `;

// const FooterBadge = styled(Badge)`
//   margin-right: ${(props) => props.theme.spacing(1)};
//   span {
//     background-color: ${(props) =>
//       props.theme.sidebar.footer.online.background};
//     border: 1.5px solid ${(props) => props.theme.palette.common.white};
//     height: 12px;
//     width: 12px;
//     border-radius: 50%;
//   }
// `;

// const SidebarFooter = ({ ...rest }) => {
//   // const { user } = useAuth();

//   return (
//     <Footer {...rest}>
//       <Grid container spacing={2}>
//         <Grid item>
//           <FooterBadge
//             overlap="circular"
//             anchorOrigin={{
//               vertical: "bottom",
//               horizontal: "right",
//             }}
//             variant="dot"
//           >
//             {<Avatar alt={"Gozerman"} src={""} />}
//             {/* Demo data */}
//             {
//               <Avatar
//                 alt="Lucy Lavender"
//                 src="/static/img/avatars/avatar-1.jpg"
//               />
//             }
//           </FooterBadge>
//         </Grid>
//         <Grid item>
//           {<FooterText variant="body2">{"Gozerman"}</FooterText>}
//           {/* Demo data */}
//           {<FooterText variant="body2">Lucy Lavender</FooterText>}
//           <FooterSubText variant="caption">UX Designer</FooterSubText>
//         </Grid>
//       </Grid>
//     </Footer>
//   );
// };

const SidebarDefaultFooter = ({ ...rest }) => {
  const { displayName, email } = useContext(GlobalContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const footerBackground = theme?.sidebar?.footer?.background;
  const footerTextColor = footerBackground ? theme.palette.getContrastText(footerBackground) : theme.palette.text.primary;
  const footerSecondaryColor = alpha(footerTextColor, 0.7);
  const userLabel = displayName || email || "User";
  const initials = userLabel
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

  const handleFooterClick = () => {
    navigate("/profile");
  };

  const handleFooterKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleFooterClick();
    }
  };

  return (
    <Footer {...rest}>
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
        role="button"
        tabIndex={0}
        aria-label="Open profile"
        onClick={handleFooterClick}
        onKeyDown={handleFooterKeyDown}
      >
        <Avatar
          aria-label={`${userLabel} profile`}
          sx={{
            width: 36,
            height: 36,
            bgcolor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            fontWeight: 600,
          }}
        >
          {initials || "U"}
        </Avatar>
        <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <Typography variant="body2" sx={{ color: footerTextColor, fontWeight: 600 }} noWrap>
            {userLabel}
          </Typography>
          {email ? (
            <Typography variant="caption" sx={{ color: footerSecondaryColor }} noWrap>
              {email}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Footer>
  );
};

export default SidebarDefaultFooter;
